import { Box, Typography } from '@mui/material';
import Tooltip from '@/components/Common/Tooltip';
import { titleCase } from 'utils/helperFunctions';

export const normalizeArray = (value: string | string[] | undefined | null): string[] => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string' && value.trim()) return [value];
  return [];
};

export const normalizeSingle = (value: string | string[] | undefined | null): string => normalizeArray(value)[0] || '';

export const getSentimentColor = (value: string): string => {
  switch (value?.toLowerCase()) {
    case 'satisfied':
    case 'positive':
      return '#16A34A';
    case 'neutral':
    case 'mixed':
      return '#195EFF';
    case 'frustrated':
    case 'challenging':
      return '#EE7F00';
    case 'churn risk':
    case 'extremely negative':
      return '#DA0808';
    default:
      return '#777777';
  }
};

export const getColumnBadges = (data: string | string[], bgColor: string, color: string) => {
  const Badge = ({ label }: { label: string }) => {
    return label ? (
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          padding: '1px 12px',
          fontWeight: 400,
          color: color,
          backgroundColor: bgColor,
          borderRadius: '100px',
          whiteSpace: 'nowrap'
        }}
      >
        {titleCase(label)}
      </Typography>
    ) : (
      ''
    );
  };

  const TooltipComponent = ({ items }: { items: string[] }) => (
    <Box display='flex' flexWrap='wrap' gap={0.6} maxWidth={200}>
      {items.map((badge, idx) => (
        <Box key={idx}>
          <Badge label={badge} />
        </Box>
      ))}
    </Box>
  );

  if (typeof data === 'string') {
    return <Badge label={data} />;
  }

  return data.length > 1 ? (
    <Box display='flex' flexDirection='row' gap={0.8}>
      <Badge label={data[0]} />
      <Tooltip title={<TooltipComponent items={data.slice(1)} />} bgColor='white'>
        <Typography
          color='#4B22A8'
          fontSize='12px'
          fontWeight={400}
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          +{data.length - 1}
        </Typography>
      </Tooltip>
    </Box>
  ) : (
    <Badge label={data[0]} />
  );
};

export const getSeverityBadges = (severity: string) => {
  switch (severity?.toLowerCase()) {
    case 'low':
    case 'trivial':
      return getColumnBadges(severity, '#E9FBEF', '#16A34A');
    case 'medium':
    case 'moderate':
      return getColumnBadges(severity, '#FFF3E5', '#EE7F00');
    case 'high':
    case 'delete':
    case 'critical':
      return getColumnBadges(severity, '#FFE5E5', '#DA0808');
    default:
      return getColumnBadges(severity, '#ECECEC', '#777777');
  }
};
